<template>
    <div class="header">
  
      <div class="container33 theme-showcase" v-if="(topimg != '' && topimg != null)">
        <img :src="topimg" style="max-width: 100%; display:block; margin:0 auto;" :style="topimgWidth==0?'width:100%;':('width:'+topimgWidth+'px;')"/>
      </div>


      <div v-if="regmode==1" style="display:flex; text-align:center; background:#cce6ff; margin:12px auto; " :style="'max-width:100%; width:'+FormWidth+'px;'">
      <div style="flex:1; padding:2px 0; ">1.Registration Profile</div>
      <div style="flex:1;  padding:2px 0; color:#fff; background:#23468c;">2.Confirmation</div>
    </div>

    <div v-if="regmode==2" style="display:flex; text-align:center; background:#cce6ff; margin:12px auto; " :style="'max-width:100%; width:'+FormWidth+'px;'">
      <div style="flex:1; padding:2px 0;">1.Registration Profile</div>
      <div style="flex:1;  padding:2px 0; ">2.Payment</div>
      <div style="flex:1;  padding:2px 0;  color:#fff; background:#23468c;">3.Confirmation</div>
    </div>
  
      <div class="container11 theme-showcase" :style="'max-width:100%; width:'+FormWidth+'px; min-height: 200px'">
  
        <div v-if="FinishTxt!=''" style="margin: 30px 0;" v-html="FinishTxt"></div>
        <div v-else v-html="FinishHtml"></div>
  
      </div>
  
      <div class="container33 theme-showcase" v-if="(btmimg != '' && btmimg != null)">
        <img :src="btmimg" style="max-width: 100%; display:block; margin:0 auto;"  :style="BottomImgWidth==0?'width:100%;':('width:'+BottomImgWidth+'px;')" />
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
    name: 'homeheader',
    data: function () {
      return {
        topimg: "",
        topimgWidth:0,
        BottomImgWidth:0,
        fieldlist: '',
        vallist: [],
        fieldval: [],
        fieldval2: [],
        fieldvalArr: [],
        imgsUrl: [],
        btmimg: '',
        checkList: [],
        btnDis: false,
        endtxt:'',
        FinishTxt:'',
        FinishHtml:'',
      FormWidth:0,
      FormMarginTop:0,
      FormMarginBtm:0,
      qrcodeurl:'',
      regmode:1,
      }
    },
    computed: {
    },
    methods: {
      getImg(){
        // var userJson = JSON.parse(localStorage.getItem('userJson'));
        // axios.post('/api/Visitor/getQrcode?data='+ this.no +'&format=2048&w=300&h=300&m=1',
        //   {
        //     code: this.id
        //   }
        // )
        //   .then((res)=>{
        //     console.log(res);
        //     this.qrcodeurl = res.data;
            
        //   })
      },
  
      loadEvent() {
        this.loading = true;
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        axios.post('/api/event/getOne?finish=1&code=' + this.id+'&no='+this.no,
          {
            code: this.id,
            finish:1,
            no:this.no
          }
        )
          .then(this.loadDataSucc)
      },
      loadDataSucc(res) {
        this.loading = false;
        res = res.data
        console.log(res);
        if (res && res.Code == 200) {
          var item = res;
          console.log(item);
          this.eventId = item.id;
            this.eventname = item.eventName;
            this.address = item.address;
            this.eventstartdate = item.beginDT;
            this.eventenddate = item.endDt;
            this.endtxt = item.endTxt;
            var FinishTxt = item.finishTxt;
            if(FinishTxt!=null && FinishTxt.indexOf('{{Qrcode}}')>=0){
              FinishTxt= FinishTxt.replace('{{Qrcode}}','<img src='+ '/api/Visitor/getQrcode?data='+ this.no +'&format=2048&w=200&h=200&m=1' +' />');
            }
            this.FinishTxt = FinishTxt;
            var FinishHtml=item.finishHtml;
            if(FinishHtml!=null && FinishHtml.indexOf('{{Qrcode}}')>=0){
              FinishHtml = FinishHtml.replace('{{Qrcode}}','<img src='+ '/api/Visitor/getQrcode?data='+ this.no +'&format=2048&w=200&h=200&m=1' +' />');
            }
            this.FinishHtml=FinishHtml;
          this.topimg = item.topimgUrl;
          this.topimgWidth = item.TopImgWidth;
          this.BottomImgWidth=item.BottomImgWidth,
      this.FormWidth=item.FormWidth;
      this.FormMarginTop=item.FormMarginTop;
      this.FormMarginBtm=item.FormMarginBtm;
          this.btmimg = item.bottomImgUrl;

          for(var i =0; i<item.catelist.length;i++){
            if (item.catelist[i].id == this.cate) {
              if(item.catelist[i].payment){
                this.regmode = 2;
              }else{
                this.regmode=1;
              }
            }
          }

        } else {
          if (res && res.Code == 301) {
            localStorage.removeItem('userJson');
            this.$router.replace('/login');
          }
        }
      },
  
  
    },
    mounted() {
      const id = this.$route.query.id;
      const cate = this.$route.query.cate;
      const no = this.$route.query.no;
      this.id = id;
      this.cate = cate;
      this.no=no;
      this.getImg();
      this.loadEvent();
    }
  }
  </script>
  <style lang="stylus" scoped>

.container33{
  margin:0 auto;
}
.container11{
  background:#fff;
  margin:auto;
  max-width:100%;
}
  </style>
  


// WEBPACK FOOTER //
// src/pages/home/regfinish.vue